export const VAKOVAKO_TOKEN_COOKIE_KEY = 'vakovako-token'
export const VAKOVAKO_COUNTRY_COOKIE_KEY = 'vakovako-country'
